var _ = require("lodash");

module.exports = function isProcessEmpty(proc) {
  if(proc.isEmpty) return true;
  switch(proc.type) {
    case "EmptyProcess":
    case "HTMLItem":
      return true;
    case "InputOption":
      return false;
    case "Seq":
    case "Par":
    case "Choice":
      return _.every(proc.subprocesses, isProcessEmpty);
    case "Dep":
    case "StopProcess":
      return false;
    case "OnlyWhen":
    case "PLabel":
    case "PLock":
    case "ChangeForm":
      return isProcessEmpty(proc.process);
    case "MarkForm":
    case "CollectSumFormItems":
    case "FlattenForm":
      return isProcessEmpty(proc.subprocess);
  }
};